module.exports = "https://tutorchat.chegg.com/static/media/ic-shape-triangle.b332c47e.svg";